export function convertNewlines(text: string): string {
  // Entferne einen führenden Zeilenumbruch, falls vorhanden
  if (text.charAt(0) === '\n') {
    text = text.slice(1)
  }
  // Ersetze alle Newlines durch <br>
  return text.replace(/\n/g, '<br>')
}
